import {motion} from 'framer-motion';
import styled from 'styled-components';

export const StyledContainer = styled.div<{bottomOffset?: number}>`
  position: fixed;
  bottom: ${(props) =>
    props.bottomOffset ? `${props.bottomOffset}px` : '16px'};
  right: 16px;
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
  z-index: 1;
`;

export const ChatIcon = styled.div`
  z-index: 1;
  cursor: pointer;
  background: #0040c5;
  border-radius: 50%;
  justify-content: center;
  display: flex;
  padding: 8px;
  width: 64px;
  height: 64px;
  align-items: center;
`;

export const Header = styled.div`
  display: flex;
  align-self: end;
`;

export const StyledDiv = styled.div`
  position: relative;
  z-index: 99;
`;

// Tooltip
export const TooltipContent = styled.div`
  color: white;
  text-align: center;
  padding: 5px;
  border-radius: 25px;
  opacity: 0;
  transition: opacity 0.3s;
  width: 136px;
  height: 30px;
  background: #0040c5;
  span {
    padding: 0 8px;
  }
`;

export const MessageBubble = styled(motion.div)<{
  isUser: boolean;
  isMobile: boolean;
  isNewBlock?: boolean;
}>`
  --margin-top-new-block: ${(props) => (props.isMobile ? '8px' : '16px')};
  background-color: ${(props) =>
    props.isUser ? 'rgba(0, 130, 214, 0.5)' : 'rgba(0, 30, 80, 0.25)'};
  font-size: 16px;
  line-height: 24px;
  color: #fff;
  padding: 24px;
  border-radius: ${(props) =>
    props.isUser ? '16px 0px 16px 16px' : '0px 16px 16px 16px'};
  align-self: ${(props) => (props.isUser ? 'flex-end' : 'flex-start')};
  width: 100%;
  max-width: ${(props) => (props.isMobile ? '100%' : '420px')};
  margin-top: ${(props) =>
    props.isNewBlock ? 'var(--margin-top-new-block)' : '0'};
`;

// dropdown
export const ChatPromptsDropdown = styled.div`
  position: relative;
  width: 100%;
  font-size: 14px;
  color: #ffffff;
  z-index: 1;
  width: 600px;
  background: #0161cb;

  ul {
    list-style-type: none;
    text-align: left;
    margin: 0;
    padding: 0;
  }
`;

export const ChatPromptsDropdownItem = styled.li`
  padding: 14px 16px;
  cursor: pointer;
  height: 48px;
  transition: background-color 0.2s;

  &:hover {
    background: #fff;
    text-decoration: none;
    color: rgba(0, 0, 0, 0.73);
  }
`;

export const MessageCardHeroWrapper = styled.a<{
  isMobile: boolean;
  isNewBlock?: boolean;
}>`
  display: flex;
  align-items: flex-start;
  gap: 16px;
  background-color: transparent;
  color: #fff;
  margin-bottom: 8px;
  margin-top: ${(props) =>
    props.isNewBlock && !props.isMobile ? '16px' : '8px'};
  align-self: flex-start;
  max-width: 480px;
  color: #fff;
  text-decoration: none;
`;

export const ChatPromptItem = styled.div<{lineHeight?: number}>`
  font-family: var(--font-family-text, vw-text);
  font-size: 16px;
  line-height: ${(props) =>
    props.lineHeight ? `${props.lineHeight}px` : '18px'};
`;

export const MessageCardHeroImage = styled.img<{isDesktop: boolean}>`
  width: ${(props) => (props.isDesktop ? '120px' : '97px')};
  object-fit: contain;
`;

export const MessageCardHeroDetail = styled.div`
  display: flex;
  flex-direction: column;
`;

export const PromptOption = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 12px 16px 14px 16px;
  border-radius: 40px;
  border: 2px solid rgba(255, 255, 255, 0.5);
  color: #fff;
  transition: border-color 0.2s;

  cursor: pointer;
  :hover {
    border-color: #fff;
  }
`;

export const MessageText = styled.div<{
  fontSize?: number;
  lineHeight?: number;
  fontWeight?: any;
}>`
  font-size: ${(props) => (props.fontSize ? `${props.fontSize}px` : '16px')};
  line-height: ${(props) =>
    props.lineHeight ? `${props.lineHeight}px` : '24px'};
  font-weight: ${(props) => props.fontWeight ?? 400};
`;
